import { IBase, IBaseSearchRequest } from "src/app/core/models/base";

// Numeric enums to match the backend (System.Text.Json serializes enums as numbers).
export enum WorkTimeViolationType {
  // The required lunch break was not taken inside the lunch window.
  LunchBreak = 0,
  // A time entry was started but never stopped.
  UnstoppedTimeEntry = 1
}

export enum WorkTimeViolationStatus {
  Open = 0,
  // The rule is met again after a later time entry change; no supervisor action needed.
  Corrected = 1,
  // A supervisor decided to leave the violation as it is (terminal).
  Ignored = 2
}

export interface IWorkTimeViolation extends IBase {
  employeeId: string;
  employee?: { id: string; firstName: string; lastName: string };
  date: string;
  type: WorkTimeViolationType;
  dayReportingObjectId?: string | null;
  // TimeSpan strings ("hh:mm:ss") as sent by the backend; LunchBreak only.
  windowStart?: string | null;
  windowEnd?: string | null;
  requiredBreak?: string | null;
  workTimeInWindow?: string | null;
  effectiveBreak?: string | null;
  missingBreak?: string | null;
  // UnstoppedTimeEntry only.
  timeEntryId?: string | null;
  entryStart?: string | null;
  status: WorkTimeViolationStatus;
  decisionDate?: string | null;
  decisionMakerId?: string | null;
  remark?: string | null;
  // Correction proposal computed by the search (LunchBreak only); taking it over is a manual edit.
  suggestedTimeEntryId?: string | null;
  suggestedStart?: string | null;
  suggestedStop?: string | null;
}

export interface ISearchWorkTimeViolationsRequest extends IBaseSearchRequest {
  employeeIds?: string[] | null;
  from?: Date | null;
  to?: Date | null;
  type?: WorkTimeViolationType | null;
  status?: WorkTimeViolationStatus | null;
}

export interface IIgnoreWorkTimeViolationRequest {
  id: string;
  remark?: string | null;
}
